import { auth } from '../config/firebase';

const apiBaseUrl = process.env.REACT_APP_COLLECTORS_EYE_API_URL;

if (!apiBaseUrl) {
  throw new Error('REACT_APP_COLLECTORS_EYE_API_URL is required.');
}

const API_BASE_URL = apiBaseUrl.replace(/\/+$/, '');

export class ApiError extends Error {
  constructor(status, message, code) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

export const apiRequest = async (path, options = {}) => {
  const headers = new Headers(options.headers);

  if (options.body !== undefined && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const user = auth.currentUser;
  if (!user) {
    throw new ApiError(401, 'Sign in before using admin API routes.', 'unauthorized');
  }
  headers.set('Authorization', `Bearer ${await user.getIdToken()}`);

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: options.method || 'GET',
    headers,
    body: options.body === undefined ? undefined : JSON.stringify(options.body)
  });

  const text = await response.text();
  let payload = {};
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch {
      if (!response.ok) {
        throw new ApiError(response.status, `API request failed with status ${response.status}`);
      }
      return undefined;
    }
  }

  if (!response.ok) {
    throw new ApiError(
      response.status,
      payload.error?.message || `API request failed with status ${response.status}`,
      payload.error?.code
    );
  }

  return payload.data;
};
